import type { TFunction } from "i18next";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import { u3125FormatInvoiceDeleteLabel, type U3125InvoiceSearchRow } from "../../U3125Service";

interface U3125FactureDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3125InvoiceSearchRow>;
  t: TFunction;
  NS: string;
}

function U3125FactureDeleteDlg({ handleDelete, t, NS }: U3125FactureDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">{t("msgDeleteInvoice", { count: handleDelete.selectedRows().length, ns: NS })}</p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handleDelete.selectedRows().map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {u3125FormatInvoiceDeleteLabel(row)}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3125FactureDeleteDlg;
